import React from 'react';

function ComingSoon({ children }) {
    return (
        <div className="relative">
            {/* Overlay */}
            <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-70 flex items-center justify-center z-50">
                <span className="text-white text-5xl font-bold">Coming Soon</span>
            </div>
            
            {/* Blurred Content */}
            <div className="blur-sm">{children}</div>
        </div>
    );
}

export default ComingSoon;